import { render, staticRenderFns } from "./admMuestra-finanzas.vue?vue&type=template&id=beada8d0&"
import script from "./admMuestra-finanzas.vue?vue&type=script&lang=js&"
export * from "./admMuestra-finanzas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports